<ng-container *transloco="let t">
  <div
    class="option-heading"
    [ngClass]="{ 'ui-clickable': collapsible() }"
    (click)="collapsible() && toggleIsOpen()"
  >
    <div>
      <p class="option-name">
        {{ name() }}
      </p>

      @if (instructions()) {
        <h3 class="option-instructions">{{ instructions() }}</h3>
      }
    </div>
    <div class="option__right-column">
      @if (displayCondition() && isRequired()) {
        <pxw-tag type="danger" [uppercase]="false" size="xs">
          {{ t('product.optionSelectionRequired') }}
        </pxw-tag>
      }
      @if (collapsible()) {
        <pxw-icon
          class="option__toggle"
          [ngClass]="{ 'option__toggle--open': isOpen() }"
          icon="chevron-down"
          size="sm"
        />
      }
    </div>
  </div>
  <div class="option-items" [hidden]="!displayContent()">
    <ng-content></ng-content>
  </div>
</ng-container>
